/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IObrienFaqData } from './obrien-faq.data';
import { IObrienFaqProps } from './obrien-faq.props.autogenerated';

export interface IObrienFaqViewProps extends IObrienFaqProps<IObrienFaqData> {

}

/**
 *
 * ObrienFaq component
 * @extends {React.PureComponent<IObrienFaqProps<IObrienFaqData>>}
 */
class ObrienFaq extends React.PureComponent<IObrienFaqProps<IObrienFaqData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default ObrienFaq;
